import { render, staticRenderFns } from "./CDialogCorporate.vue?vue&type=template&id=31b74558&scoped=true"
import script from "./CDialogCorporate.vue?vue&type=script&setup=true&lang=js"
export * from "./CDialogCorporate.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CDialogCorporate.vue?vue&type=style&index=0&id=31b74558&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b74558",
  null
  
)

export default component.exports